module.exports = __webpack_public_path__ + "media/images/riders/small/ALEXANDRA_ENGEN-7420f8c9c9f0c7ce4eba5b1b530ff6e0.png";